const defaultState = {
  customers: null,
  portfoliosList: {},
  error: null,
  fetching: false,
  fetched: false
};

const getPortfoliosReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'PORTFOLIOS_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'PORTFOLIOS_ALL_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'PORTFOLIOS_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, portfolios: action.payload.data
      };
    }
    case 'PORTFOLIOS_ALL_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, portfoliosList: action.payload
      };
    }
    case 'PORTFOLIOS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customers: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getPortfoliosReducer;


// WEBPACK FOOTER //
// ./src/reducers/VXC/getPortfolios.js